import { get } from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Form, Dropdown, Button } from "semantic-ui-react";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class ProjectFilters extends Component {
  static propTypes = {
    initialValues: PropTypes.object,
    onFilterChange: PropTypes.func.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "filters"
  };

  constructor(props) {
    super(props);

    this.state = {
      filters: {
        direction: get(props, "initialValues.filters.direction", "desc"),
        marking: get(props, "initialValues.filters.marking", "current"),
        order: get(props, "initialValues.filters.order", "createdAt"),
        name: get(props, "initialValues.filters.name", "") // used for initial basic search
      }
    };
  }

  // -- HANDLERS--//

  onFilterChange = (evt, data) => {
    this.setState(
      { filters: { ...this.state.filters, [data.name]: data.value } },
      this.onStateChange
    );
  };

  onSearchChange = (evt, data) => {
    this.setState({
      filters: { ...this.state.filters, [data.name]: data.value }
    });
  };

  onResetFilters = () => {
    this.setState(
      {
        filters: {
          direction: "desc",
          marking: "current",
          order: "createdAt",
          name: ""
        }
      },
      this.onStateChange
    );
  };

  onStateChange = () => {
    const { filters, view } = this.state;
    this.props.onFilterChange({ filters, view });
  };

  // -- RENDER --//

  render() {
    const { copyKey, copy } = this.props;
    const {
      filters: { marking, order, direction }
    } = this.state;

    // view fields removed until they're updated with new permissions implementation
    return (
      <Form size="mini" className="clearfix">
        <Form.Group inline className="filter-group">
          <Form.Field
            control={Dropdown}
            name="marking"
            value={marking}
            selection
            options={[
              {
                text: copy(`${copyKey}.marking.current`),
                key: "current",
                value: "current"
              },
              {
                text: copy(`${copyKey}.marking.archived`),
                key: "archived",
                value: "archived"
              },
              {
                text: copy(`${copyKey}.marking.all`),
                key: "all",
                value: "all"
              }
            ]}
            onChange={this.onFilterChange}
          />

          <Form.Field
            control={Dropdown}
            name="order"
            value={order}
            selection
            options={[
              {
                text: copy(`${copyKey}.order.createdAt`),
                key: "createdAt",
                value: "createdAt"
              },
              {
                text: copy(`${copyKey}.order.updatedAt`),
                key: "updatedAt",
                value: "updatedAt"
              },
              {
                text: copy(`${copyKey}.order.deletedAt`),
                key: "deletedAt",
                value: "deletedAt"
              },
              {
                text: copy(`${copyKey}.order.id`),
                key: "id",
                value: "id"
              }
            ]}
            onChange={this.onFilterChange}
          />

          <Form.Field control={Button.Group} basic size="tiny">
            <Button
              name="direction"
              value="asc"
              icon="sort content ascending"
              compact
              active={direction === "asc"}
              onClick={this.onFilterChange}
            />
            <Button
              name="direction"
              value="desc"
              icon="sort content descending"
              compact
              active={direction === "desc"}
              onClick={this.onFilterChange}
            />
          </Form.Field>
        </Form.Group>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps, null)(ProjectFilters);
